function e(e,t,a,n){e._m(t);var u=a("29db1a4e");e._(t,"default",u,"useResetIconStyle");}